import { history } from "./history"
import { routeTemplates } from "./routeTemplates"
import { mapValues } from "lodash"

export const navigation = mapValues(routeTemplates, (rt) => {
  return {
    createHref: (...args) => {
      return `#${rt.build(...args)}`
    },
    replace: (...args) => history.replace(rt.build(...args)),
    push: (...args) => history.push(rt.build(...args)),
  }
})
